import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ReportHistory } from '../../interfaces/configuration/report-history';

@Injectable()

export class ReportHistoryService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<ReportHistory[] | boolean> {
    return new Observable<ReportHistory[] | boolean>((o: Subscriber<ReportHistory[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('instellingen.invoer.histories.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ReportHistory[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<ReportHistory | boolean> {
    return new Observable<ReportHistory | boolean>((o: Subscriber<ReportHistory | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('instellingen.invoer.histories.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ReportHistory>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('instellingen.invoer.histories.update', {':id': id}), formData);
  }
}
